import React from 'react'
import ReactDOM from 'react-dom'
import {connect} from 'react-redux'
import AD from 'react-google-publisher-tag'

import {
  VIEWPORT_MAX_WIDTH_PHONE
} from './config/constants'

class ChatBotSlotAdvertisement extends React.Component {
  constructor (props) {
    super(props)

    this.state = {}

    this.adjustAdvSize = this.adjustAdvSize.bind(this)
  }

  adjustAdvSize () {
    if (this.refs.adContainer) {
      const width = this.refs.adContainer.offsetWidth

      const dimensions = this.getScaledDimensions(this.props.heightSlot, width, this.props.dimensions)

      const iframe = ReactDOM.findDOMNode(this.refs.adContainer).querySelector('iframe')

      if (iframe) {
        const img = iframe.contentDocument.querySelector('img')

        iframe.width = dimensions[0]
        iframe.height = dimensions[1]

        if (img) {
          img.width = dimensions[0]
          img.height = dimensions[1]
        }
      }
    }
  }

  getAdPath () {
    return `/${this.props.networkId}/${this.props.tagId}`
  }

  getScaledDimensions (heightSlot = this.props.heightSlot, width = this.props.maxWidth, dimensions = this.props.dimensions) {
    const scaledDimensions = this.getDimensions(heightSlot, width, dimensions)

    if (scaledDimensions[0] < width) width = scaledDimensions[0]

    const height = (scaledDimensions[1] / scaledDimensions[0]) * width

    return [width, height]
  }

  getDimensions (heightSlot = this.props.heightSlot, width = this.props.maxWidth, dimensions = this.props.dimensions) {
    const {square, mobile, leaderboard: desktop} = dimensions

    if (heightSlot === square[1]) {
      return square
    }
    else if (width > mobile[0]) {
      return desktop
    }
    else {
      return mobile
    }
  }

  getClassName () {
    return 'rchat-ad-chat-bot-slot'
  }

  render () {
    if (!this.props.tagId || !this.props.networkId) return false
    if (this.props.isModerated === true && this.props.isModeratedEnabled === false) return false

    const [width, height] = this.getScaledDimensions()

    return (
      <div ref='adContainer' style={{width, height}}>
        <AD
          ref='ad' path={this.getAdPath()}
          dimensions={this.getDimensions()} responsive={false}
          canBeLower={false}
          className={this.getClassName()}
          onSlotRenderEnded={this.adjustAdvSize}
          onImpressionViewable={this.adjustAdvSize}/>
      </div>
    )
  }
}

ChatBotSlotAdvertisement.defaultProps = {
  maxWidth: 218,
  dimensions: {
    square: [300, 250],
    mobile: [320, 50],
    leaderboard: [728, 90]
  },
  target: 'chatPane'
}

const mapStateToProps = (state) => {
  return {
    tagId: state.getIn(['advertisements', 'chatBotSlot', 'tagId']),
    networkId: state.getIn(['advertisements', 'settings', 'networkId']),
    heightSlot: state.getIn(['advertisements', 'chatBotSlot', 'advHeight']),
    isModeratedEnabled: state.getIn(['advertisements', 'settings', 'isModeratedGroupChatEnabled'])
  }
}

const ChatBotSlotAdvertisementContainer = connect(
  mapStateToProps
)(ChatBotSlotAdvertisement)

export default ChatBotSlotAdvertisementContainer


/** WEBPACK FOOTER **
 ** ./modules/shared/chat_bot_slot_advertisement.js
 **/